import { MessageOptions, IMessageAction } from './'
import { Utils } from '../../helpers'

export class Message {
  public id: string
  public message: string
  public topic: string
  public category: 'error'|'info'|'warning'|'success'
  public subject: string
  public actions: IMessageAction[]
  public timestamp: Date

  public static DEFAULT_CATEGORY = Object.freeze('info') as 'info'
  public static DEFAULT_SUBJECT = Object.freeze('default')
  public static DEFAULT_TOPIC = Object.freeze('default')

  constructor(
    private options: MessageOptions,
    private _utils: Utils
  ) {
    if (this._utils.isValueEmpty(options.id) || this._utils.isValueEmpty(options.message)) {
        throw new Error('Options "id" and "message" must be provided and cannot be blank!')
      }

    this.id = options.id
    this.message = options.message
    this.topic = options.topic || Message.DEFAULT_TOPIC
    this.category = options.category || Message.DEFAULT_CATEGORY
    this.subject = options.subject || Message.DEFAULT_SUBJECT
    this.timestamp = options.timestamp || new Date()
    this.actions = options.actions || []
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/models/message/message.ts